import React from 'react';
import { FiArrowUpRight, FiUsers, FiZap } from 'react-icons/fi';

const PortfolioItem = ({ portfolio }) => {
    const href = `/portfolio-details/${portfolio.id}`;

    return (
        <article className="blackwave-fleet-card">
            <a href={href} className="blackwave-fleet-card__media" aria-label={`Zobacz ${portfolio.title}`}>
                <img
                    src={portfolio.portfolioImage}
                    alt={`${portfolio.title.trim()} — motorówka na wynajem w Augustowie`}
                    width="960"
                    height="720"
                    loading="lazy"
                    decoding="async"
                />
                <span className="blackwave-fleet-card__price">od {portfolio.date} / 2h</span>
            </a>
            <div className="blackwave-fleet-card__body">
                <div className="blackwave-fleet-card__heading">
                    <div>
                        <p>Motorówka TEXAS · Augustów</p>
                        <h3><a href={href}>{portfolio.title}</a></h3>
                    </div>
                    <a href={href} className="blackwave-fleet-card__arrow" aria-label={`Szczegóły ${portfolio.title}`}>
                        <FiArrowUpRight aria-hidden="true" />
                    </a>
                </div>
                <div className="blackwave-fleet-card__specs" aria-label="Najważniejsze parametry">
                    <span><FiUsers aria-hidden="true" /> {portfolio.capacity}</span>
                    <span><FiZap aria-hidden="true" /> {portfolio.engine}</span>
                </div>
                <p className="blackwave-fleet-card__description">{portfolio.shortDescription || portfolio.excerpt}</p>
                <a href={href} className="blackwave-fleet-card__link">Zobacz szczegóły i cennik <FiArrowUpRight aria-hidden="true" /></a>
            </div>
        </article>
    );
};

export default PortfolioItem;
